import { BookTextIcon } from 'lucide-react';

import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Dialog, DialogBody, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { FeaturedIcon } from '@/components/ui/featured-icon';

interface QuizBuilderForceEditAlertDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export default function QuizBuilderForceEditAlertDialog(quizBuilderForceEditDialogProps: QuizBuilderForceEditAlertDialogProps) {
  const { open, onOpenChange, onConfirm } = quizBuilderForceEditDialogProps;

  const handleOnConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent className={'sm:max-w-108'}>
        <DialogBody>
          <DialogHeader>
            <FeaturedIcon>
              <BookTextIcon />
            </FeaturedIcon>
            <DialogTitle className="overflow-clip text-wrap whitespace-normal">Czy napewno chcesz unieważnić odpowiedzi?</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 p-4">
            <Alert>
              <AlertDescription>Istnieją zarejestrowane próby tego quizu. Po weryfikacji obecnych odpowiedzi co najmniej jedna z nich stanie się nieprawidłowa</AlertDescription>
            </Alert>

            <DialogDescription className={'text-text-secondary text-sm'}></DialogDescription>
          </div>
        </DialogBody>
        <DialogFooter>
          <Button type="button" variant={'tertiary'} onClick={() => onOpenChange(false)}>
            Anuluj
          </Button>
          <Button type="button" onClick={handleOnConfirm}>
            Potwierdź
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
